import { Box, Label } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { OnChangeValue, ActionMeta } from 'react-select';
import { Domain } from '@tiendanube/common/src/enums';
import MultiSelect from 'commons/components/MultiSelect';
import { OptionType } from 'commons/components/MultiSelect/multiSelectStyleConfig';

interface OrderPaymentMethodsFilterProps {
  defaultValue: OptionType[];
  paymentMethodOptions: OptionType[];
  onChange: (
    newValue: OnChangeValue<OptionType, true>,
    action: ActionMeta<OptionType>,
  ) => void;
}

function OrderPaymentMethodsFilter({
  defaultValue,
  paymentMethodOptions,
  onChange,
}: Readonly<OrderPaymentMethodsFilterProps>): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS);

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Label htmlFor="payment-method-select">{t('filter.paymentMethod')}</Label>
      <MultiSelect
        inputId="payment-method-select"
        defaultValue={defaultValue}
        options={paymentMethodOptions}
        placeholder={t('filters.paymentMethod.all')}
        onChange={onChange}
      />
    </Box>
  );
}

export default OrderPaymentMethodsFilter;
